export default __webpack_public_path__ + "static/supremeLogo-4fa9d5fce706d01c2daf66bfc5e88298.png";